import styled, { css } from 'styled-components'
import { ThemeSelectors, TypeMini } from '@at/design-system-foundation'
import { StyledSearchListingDetailsTitle } from '../../components/search-listing-details/search-listing-details.styles'
import { BREAKPOINTS } from '@at/window-utils/lib/responsive-utils/match-media.util'
import { BadgeType } from '../../__generated__/fed-graphql-types'

export const StyledSearchListing = styled.div`
    :hover {
        cursor: pointer;
    }
    position: relative;
    // Space for fixed header on mobile, desktop allows user to see a peak of listing above so the user knows more results are above.
    scroll-margin-top: 70px;
    height: 100%;
`

export const StyledGPTContainer = styled.div`
    height: 100%;
    div {
        height: 100% !important;

        @media (min-width: ${BREAKPOINTS.MEDIUM}px) {
            iframe {
                height: 100%;
            }
        }
    }
`

export const StyledSearchListingLabel = styled(TypeMini)<{ $type: BadgeType; $badges?: boolean }>`
    ${({ theme, $type, $badges }) => {
        let tab: { background: string; colour: string }

        switch ($type) {
            case BadgeType.PI_LOW: {
                tab = {
                    background: theme.color.priceIndicator.bgFill.low,
                    colour: theme.color.priceIndicator.text.low,
                }
                break
            }

            case BadgeType.PI_GREAT: {
                tab = {
                    background: theme.color.priceIndicator.bgFill.great,
                    colour: theme.color.priceIndicator.text.great,
                }

                break
            }

            case BadgeType.PI_GOOD: {
                tab = {
                    background: theme.color.priceIndicator.bgFill.good,
                    colour: theme.color.priceIndicator.text.good,
                }

                break
            }
            case BadgeType.PI_FAIR: {
                tab = {
                    background: theme.color.priceIndicator.bgFill.fair,
                    colour: theme.color.priceIndicator.text.fair,
                }

                break
            }
            case BadgeType.PI_HIGH: {
                tab = {
                    background: theme.color.priceIndicator.bgFill.high,
                    colour: theme.color.priceIndicator.text.high,
                }

                break
            }
            case BadgeType.WRITE_OFF_CATEGORY: {
                tab = {
                    background: theme.color.bgFill.caution,
                    colour: theme.color.text.intense.onFill,
                }
                break
            }
            case BadgeType.BRAND_NEW:
            case BadgeType.DUE_AT_SELLER:
            default: {
                tab = {
                    background: $badges ? theme.color.bgFill.highlight : theme.color.bgFill.default,
                    colour: $badges ? theme.color.text.highlight.onFill : theme.color.text.offer.onFill,
                }
                break
            }
        }

        return css`
            align-self: center;
            background-color: ${tab.background};
            border-radius: 3px;
            border: 1px solid ${tab.background};
            color: ${tab.colour};
            display: inline-block;
            line-height: 1;
            font-variation-settings: 'wght' 500;
            min-width: 86px;
            text-align: center;
            padding: 3px 8px;
            &:last-of-type {
                margin-right: 0;
            }

            &:first-of-type {
                margin-left: 0;
            }
        `
    }};
`
interface StyledListingStandoutProps {
    $capitalise?: boolean
}

export const StyledListingStandout = styled(TypeMini)<StyledListingStandoutProps>`
    position: absolute;
    top: -20px;
    left: 0;
    color: ${({ theme }) => theme.color.text.default};
    ${({ $capitalise }) => $capitalise && 'text-transform: capitalize;'};
`

export const StyledSearchListingAdvert = styled.div`
    ${({ theme }) => {
        return css`
            & > div {
                flex-direction: column;
                display: flex;
                width: 100%;

                min-height: 0;
            }
            text-decoration: none;
            color: inherit;
            position: relative;
            background: ${theme.color.bgSurface.default};
            box-shadow: 0 1px 5px 0 ${theme.color.border.default};
            border-radius: 16px;
            overflow: hidden;
            .carousel-button-wrapper {
                opacity: 0;
            }
            &:hover,
            &:focus-within {
                ${StyledSearchListingDetailsTitle} > h3 {
                    color: ${theme.color.text.link.hover};
                }
                .carousel-button-wrapper {
                    opacity: 1;
                    transition: 0.3s ease-in-out;
                }
            }
        `
    }};
`

export const StyledSearchListingAdvertColumn = styled.div<{ $isFlexibleFinance?: boolean }>`
    display: flex;
    flex-direction: column;
    width: 100%;
    @media (min-width: ${BREAKPOINTS.MEDIUM}px) {
        height: ${({ $isFlexibleFinance }) => ($isFlexibleFinance ? '228px' : '204px')};
    }

    & > ul {
        padding: ${({ theme }) => ThemeSelectors.getGridUnit(theme)} ${({ theme }) => ThemeSelectors.getGridUnit(theme)}
            0 ${({ theme }) => ThemeSelectors.getGridUnit(theme)};
    }
`

export const DetailsPadding = styled.div`
    padding: 0 8px;
`
